<div class="row" *ngIf="technician">
    <div class="col-md-4">
        <div class="row margin-top-8">
            <div class="col-md-5 label">{{ "general.firstname" | translate }}:</div>
            <div class="col-md-7">
                <input type="text" pInputText [(ngModel)]="technician.Firstname"/>
            </div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-5 label">{{ "general.surname" | translate }}:</div>
            <div class="col-md-7">
                <input type="text" pInputText [(ngModel)]="technician.Surname"/>
            </div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-5 label">
                {{
                "bikeshop.modal.add_edit_user.technician_form.hours_per_day"
                    | translate
                }}:
            </div>
            <div class="col-md-7">
                <input type="number" pInputText [(ngModel)]="technician.HoursPerDay"/>
            </div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-5 label">{{ "general.active" | translate }}:</div>
            <div class="col-md-7">
                <p-inputSwitch [(ngModel)]="technician.IsActive"></p-inputSwitch>
            </div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-5 label">
                {{
                "bikeshop.modal.add_edit_user.technician_form.linked_to_user"
                    | translate
                }}:
            </div>
            <div class="col-md-7">
                <p-dropdown
                        [options]="userDropDown"
                        [(ngModel)]="technician.UserID"
                ></p-dropdown>
            </div>
        </div>
        <div class="row margin-top-16">
            <div class="col-md-5"></div>
            <div class="col-md-7">
                <button
                        pButton
                        type="button"
                        class="p-button-raised full-width"
                        label="{{
            'bikeshop.modal.add_edit_user.technician_form.button.save_technician'
              | translate
          }}"
                        (click)="saveTechnician()"
                        [disabled]="busy"
                ></button>
            </div>
        </div>
    </div>
    <div class="col-md-8">
        <div style="padding: 8px;background: #eeeeee;border: 1px solid #dddddd;">
            <div class="row">
                <div class="col-md-10">
                    <h5>
                        {{
                        "bikeshop.modal.add_edit_user.technician_form.calendar_events"
                            | translate
                        }}
                    </h5>
                </div>
                <div class="col-md-2">
                    <div
                            pTooltip="{{
              'bikeshop.modal.add_edit_user.technician_form.create_a_new_event'
                | translate
            }}"
                            tooltipPosition="left"
                            tooltipZIndex="10000"
                            class="fa fa-calendar-plus-o font-button pull-right"
                            (click)="event = {}; addEvent.toggle($event)"
                    ></div>
                </div>
                <div style="position: absolute;right: 390px;top: 28px;">
                    <p-overlayPanel
                        #addEvent
                        [dismissable]="false"
                        [showCloseIcon]="true"
                    >
                        <app-event
                                [event]="event"
                                [user]="user"
                                (refresh)="getTechnicianEvents()"
                                [eventPopup]="addEvent"
                                [leaveEvent]="leaveEvent"
                        ></app-event>
                    </p-overlayPanel>
                </div>
            </div>
            <div class="margin-top-8">
                <p-table
                    #eventsTable
                    [columns]="eventColumns"
                    [value]="events"
                    [paginator]="true"
                    [rows]="5"
                >
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                                {{ col.header }}
                                <p-sortIcon
                                        [field]="col.field"
                                        style="vertical-align: middle;"
                                ></p-sortIcon>
                            </th>
                            <th style="width:90px;"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-event let-columns="columns">
                        <tr>
                            <td *ngFor="let col of columns">
                                <div>
                                    {{
                                    col.type === "date"
                                        ? (event[col.field] | date: "yyyy-MM-dd HH:mm")
                                        : col.type === "recurrance"
                                            ? event[col.field] > 0
                                                ? ("general.yes" | translate)
                                                : ("general.no" | translate)
                                            : event[col.field]
                                    }}
                                </div>
                            </td>
                            <td>
                                <div>
                                    <div
                                            pTooltip="{{
                      'bikeshop.modal.add_edit_user.technician_form.edit_this_event'
                        | translate
                    }}"
                                            tooltipPosition="left"
                                            tooltipZIndex="10000"
                                            class="fa fa-pencil font-button"
                                            (click)="editEvent.toggle($event)"
                                    ></div>
                                    <div
                                            pTooltip="{{
                      'bikeshop.modal.add_edit_user.technician_form.delete_this_event'
                        | translate
                    }}"
                                            tooltipPosition="left"
                                            tooltipZIndex="10000"
                                            class="fa fa-trash-o font-button"
                                            (click)="deleteEvent(event)"
                                    ></div>
                                    <div style="position: absolute;right: 434px;top: 65px;">
                                        <p-overlayPanel
                                            #editEvent
                                            [dismissable]="false"
                                            [showCloseIcon]="true"
                                        >
                                            <app-event
                                                    [event]="event"
                                                    [user]="user"
                                                    (refresh)="getTechnicianEvents()"
                                                    [eventPopup]="editEvent"
                                                    [leaveEvent]="leaveEvent"
                                            ></app-event>
                                        </p-overlayPanel>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
        <div class="row">
            <div *ngIf="error" class="col-md-12 errormessage">
                {{ errorMessage }}
            </div>
        </div>
    </div>
</div>
